/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlinkInstrument} from '../api'

export const useMutationUnlinkInstrument = createReactQueryMutationHook('unlinkInstrument', unlinkInstrument)
